require("component-leaflet-map");
var xhr = require("./lib/xhr");

var mapElement = document.querySelector("#fault-map");
var map = mapElement.map;
var L = mapElement.leaflet;

map.dragging.disable();
map.touchZoom.disable();
map.doubleClickZoom.disable();
map.scrollWheelZoom.disable();
map.boxZoom.disable();
map.removeControl(map.zoomControl);

map.attributionControl.setPosition("bottomleft");

// map.addEventListener("click", function(e) { console.log(e.latlng)});

map.fitBounds([[45.572,-115.224],[48.9632,-127.1008]], {animate: false});

var isTouch = false;
try {
  document.createEvent("TouchEvent");
  isTouch = true;
} catch (e) { /* no touchscreen */ }
if (isTouch) document.querySelector(".fault-map .touch-cover").classList.add("activated");

var markers = [];
var layers = [];

xhr("./assets/new-faults.geo.json", function(err, data) {

  if (err) return console.error(err);

  var geojson = L.geoJson(data, {
    style: style,
    onEachFeature(feature, layer) {
      if (feature.properties.name == "Cascadia Subduction Zone" ) {
        var coords = layer.getBounds().getCenter();
        var icon = new L.divIcon({className: 'cascadia fault-label'});
        var marker = L.marker([coords.lat, coords.lng - 0.5], {icon: icon});
        markers.push(marker);
      } else if (feature.properties.name == "Seattle" && feature.properties.year == 1992) {
        var coords = layer.getBounds().getCenter();
        var icon = new L.divIcon({className: 'seattle fault-label'});
        var marker = L.marker([coords.lat + 0.3, coords.lng - 1.4], {icon: icon});
        markers.push(marker);
      }
    }
  }).addTo(map);

  var year = 1979;

  function style(feature) {
    return {
      weight: 2,
      opacity: (feature.properties.year <= year ? "1" : "0"),
      color: (feature.properties.status == "Active" ? "#fd8d3c" : "#fed976")
    };
  }
  function restyle(feature) {
    return {
      weight: 2,
      opacity: (feature.properties.year <= year ? "1" : "0"),
      color: color(feature)
    };
  }

  var color = function(feature) {
    if (feature.properties.name == "Cascadia Subduction Zone" || feature.properties.name == "Seattle") {
      return "white";
    } else if (feature.properties.status == "Active") {
      return "#fd8d3c";
    } else {
      return "#fed976";
    }
  };

  var addFault = function() {
    document.querySelector(".fault-map .date").innerHTML = Math.floor(year);
    geojson.setStyle(style);
    year += 1;

    if (year <= 2016) {
      setTimeout(addFault, 200);
    } else {
      geojson.setStyle(restyle);
      markers.forEach(function(marker) {
        marker.addTo(map);
      });
      setTimeout(function() {
        markers.forEach(function(marker) {
          map.removeLayer(marker);
        });
        year = 1979;
        addFault();
      }, 4000);
    }
  }


  addFault();
});